import { ExportAllButton } from '../ExportAllButton';
import * as React from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch';
import { Button, Typography, Box, Link } from '@mui/material';
import { FieldGuesser } from '@api-platform/admin';
import RateReviewIcon from '@mui/icons-material/RateReview';
import { ENTRYPOINT, REVIEWS_URL } from '../../config/entrypoint';
import {
  Datagrid,
  DateField,
  List,
  TopToolbar,
  useGetOne,
  useListContext,
  useNotify,
  useRefresh,
  FunctionField,
} from 'react-admin';

export const CourseCityDateReviewCodes = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetOne('course_city_dates', { id });

  if (isLoading) {
    return null;
  }

  return (
    <>
      <List
        actions={<ReviewCodesActions />}
        empty={<Empty data={data} />}
        filter={{ courseCityDate: id }}
        resource={'review_codes'}
      >
        <Datagrid>
          <FieldGuesser source={'code'} />
          <FunctionField
            label="Link"
            render={(record) => (
              <Link
                href={`${REVIEWS_URL}/review/${record.code}`}
                target={'_blank'}
                underline="always"
              >
                {`${REVIEWS_URL}/review/${record.code}`}
                <LaunchIcon fontSize={'small'} />
              </Link>
            )}
          />
          <FieldGuesser source={'used'} />
          <DateField source={'createdAt'} locales={'de'} />
        </Datagrid>
      </List>
    </>
  );
};

const ReviewCodesActions = () => {
  const { data, isLoading } = useListContext();
  const notify = useNotify();

  if (isLoading) return null;

  const handleAllCodesClick = (e) => {
    const codes = data.map((item) => item.code);
    navigator.clipboard.writeText(codes.join(', '));
    notify(`${data.length} Codes in die Zwischenablage kopiert`, {
      type: 'success',
    });
  };

  const handleAllLinksClick = (e) => {
    const codes = data.map((item) => item.code);
    const links = codes.map((code) => `${REVIEWS_URL}/review/${code}`);
    navigator.clipboard.writeText(links.join(`, `));
    notify(`${data.length} Links in die Zwischenablage kopiert`, {
      type: 'success',
    });
  };

  return (
    <TopToolbar>
      <ExportAllButton />
      <Button
        startIcon={<RateReviewIcon />}
        color="primary"
        size={'small'}
        sx={{ lineHeight: '1.5' }}
        onClick={handleAllCodesClick}
      >
        Copy All Codes
      </Button>
      <Button
        startIcon={<RateReviewIcon />}
        color="primary"
        size={'small'}
        sx={{ lineHeight: '1.5' }}
        onClick={handleAllLinksClick}
      >
        Copy All Links
      </Button>
    </TopToolbar>
  );
};

const Empty = ({ data }) => {
  return (
    <Box flex={1} textAlign="center" m={1} mt={8}>
      <Typography variant="h4" paragraph>
        Es wurden noch keine Review Codes für diesen Termin erstellt.
      </Typography>
      <CreateReviewCodesButton data={data} />
    </Box>
  );
};

export const CreateReviewCodesButton = ({ data }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  if (!data) {
    return null;
  }

  const handleClick = () => {
    setLoading(true);
    fetch(`${ENTRYPOINT}${data.id}/generate-review-codes`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth')}`,
        'Content-Type': 'application/ld+json',
      },
      body: JSON.stringify({ foo: 'bar' }),
    })
      .then(() => {
        notify('Review Codes wurden erstellt', { type: 'success' });
        refresh();
      })
      .catch((e) => {
        notify('Error: comment not approved', { type: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      color="primary"
      variant={'contained'}
      onClick={handleClick}
      disabled={loading}
    >
      Create Review Codes
    </Button>
  );
};
